import { render } from "./BsTemplateOwnerView.vue?vue&type=template&id=90b98c4a&scoped=true"
import script from "./BsTemplateOwnerView.vue?vue&type=script&lang=js"
export * from "./BsTemplateOwnerView.vue?vue&type=script&lang=js"

import "./BsTemplateOwnerView.vue?vue&type=style&index=0&id=90b98c4a&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/user/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.12_typescript@5.6.3__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b98c4a"]])

export default __exports__